$( window ).on('load', function() {
    $(document).on('click', '.navbar .dropdown-menu', function(e) {
        var originalFocus = false;
        if (e.target.tagName == 'INPUT') {
            originalFocus = e.target;
        }
        $(this).closest('li:not(.open)').find('a.dropdown-toggle').dropdown('toggle');

        if (originalFocus) {
            $(originalFocus).focus();
        }
        e.stopPropagation();
    });
}).on('resize', function () {
    footerLinkHeights();
});

toastr.options = {
    positionClass: 'toast-bottom-right',
};

function footerLinkHeights() {
    var maxHeight = 0;

    $('h5.footer-link-header').outerHeight('auto');

    $('h5.footer-link-header').each(function (index, item) {
        maxHeight = Math.max(maxHeight, $(item).outerHeight());
    });

    $('h5.footer-link-header').outerHeight(maxHeight + 10);
}

$('body').on('click', '.quantity-decrement-button', function (e) {
    e.preventDefault();
    var id = $(this).attr('id').replace('quantity-decrement-button-', '');
    var input = $('#quantity-' + id);
    var step = parseInt(input.data('step'));
    var min = parseInt(input.data('min'));
    if(isNaN(step))step=1;
    if(isNaN(min) || min<step)min=step;
    else min = step*Math.ceil(min/step);

    input.val(function (ii, oldValue) {
        return Math.max(min, parseInt(oldValue)-step);
    });
    input.change();
}).on('click', '.quantity-increment-button', function (e) {
    e.preventDefault();
    var id = $(this).attr('id').replace('quantity-increment-button-', '');
    var input = $('#quantity-' + id);
    var step = parseInt(input.data('step'));
    var min = parseInt(input.data('min'));
    if(isNaN(step))step=1;
    if(isNaN(min) || min<step)min=step;
    else min = step*Math.ceil(min/step);

    input.val(function (ii, oldValue) {
        return (parseInt(oldValue) < min)?min:parseInt(oldValue)+step;
    });
    input.change();
});

$('input.quantity-input').on('focus', function (e) {
    $(this).data('curr-val',$(this).val());
});
$('input.quantity-input').on('change', function(e){
    var input = $(this);
    var value  = parseInt(input.val());

    if(isNaN(value) || value < 0){
        value = input.data('curr-val');
    }
    input.val(value);
});

$(document).ready(function () {
    footerLinkHeights();
});

$('body').on('click', '.user-favorite-toggle', function (e) {
    e.preventDefault();
    var $theStar = $(this);
    var webFamilyId = $theStar.attr('data-webfamily-id');
    var isFavorite = $theStar.children(':visible.is-favorite').length > 0;
    $theStar.children().hide();
    $theStar.children('.loading').show();

    var url = '/favorites/' + (isFavorite ? 'remove' : 'add') + '/' + webFamilyId;
    $.getJSON(url, function (data) {
        $theStar = $('.user-favorite-toggle[data-webfamily-id=' + data.webFamilyId + ']');
        $theStar.children().hide();
        $theStar.children(data.isFavorite ? '.is-favorite' : '.is-not-favorite').show();
        toastr.success(data.isFavorite ? 'Added to favorites.' : 'Removed from favorites.');
    }).fail(function (data) {
        $theStar.children().hide();
        $theStar.children(isFavorite ? '.is-favorite' : '.is-not-favorite').show();
    });
});